/// <amd-module name="SuiteCommerce.PhotoGallery.Photo.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PhotoGallery.Photo.Collection", ["require", "exports", "SuiteCommercePhotoGallery.Photo.Model", "Backbone"], function (require, exports, PhotoGallery_Photo_Model_1, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PhotoCollection = /** @class */ (function (_super) {
        __extends(PhotoCollection, _super);
        function PhotoCollection() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PhotoCollection.prototype, "model", {
            get: function () { return PhotoGallery_Photo_Model_1.PhotoModel; },
            enumerable: true,
            configurable: true
        });
        return PhotoCollection;
    }(Backbone_1.Collection));
    exports.PhotoCollection = PhotoCollection;
});
